module.exports = {"id":"224254","name":"Cristian Pavón","rating":"76","photo":"./data/images/photos/2/224254.png","club":{"name":"Boca Juniors","logo":"./data/images/clubs/BocaJuniors.png"},"positions":["AD","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CristianPavon0.json
// module id = 877
// module chunks = 0